<template>
  <div>
    <!-- 出货记录  配送单详细-->
    <el-dialog :visible.sync="dialogVisible" width="1200px" :title="$t('message.porderDetail')">
      <div class="table">
        <ol>

          <li class="color1">NO</li>
          <!-- 配送单号 -->
          <li class="flex15">{{ $t('message.deliveryNoteNumber') }}</li>
          <!-- 订单号 -->
          <li class="flex15">{{ $t('message.orderNumber') }}</li>
          <!-- 番号 -->
          <li class="color1">{{ $t('message.mash') }}</li>

          <!-- 出货数量 -->
          <li>{{ $t('message.ShipmentQuantity') }}</li>
          <!-- 出货时间 -->
          <li class="flex15">{{ $t('message.shippingTime') }}</li>
          <!-- 使用物流 -->
          <li>{{ $t('message.usingLogistics') }}</li>

        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="color1">{{ index + 1 }}</li>
          <!-- 配送单号 -->
          <li class="flex15">
            <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" class="a-link" target="_blank">
              {{ item.porder_sn }}
            </router-link>
          </li>
          <!-- 订单号 -->
          <li class="flex15">
            <router-link :to="'/orderDetail?order_sn=' + item.order_sn" class="a-link" target="_blank">
              {{ item.order_sn }}
            </router-link>
          </li>
          <!-- 番号 -->
          <li class="color1">{{ item.sorting }}</li>
          <!-- 出货数量 -->
          <li>{{ item.num }}</li>
          <!-- 出货时间 -->
          <li class="flex15">{{ item.datetime_delivery }}</li>
          <!-- 使用物流 -->
          <li>
            <div>
              <p v-for="(logistics, logisticsIndex) in item.logistics_name" :key="logisticsIndex">
                {{ logistics }}
              </p>
            </div>
          </li>
        </ul>
        <div class="nodata" v-if="tableData == false">
          无数据
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    porderDeliveryList(skuCodes, user_id) {
      let datas = {
        user_id,
        skuCodes,
      }
      this.$api.productManagementApi.porderDeliveryList(datas).then(res => {
        this.tableData = res.data
        this.dialogVisible = true
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  padding: 0 20px;


  .flex3 {
    flex: 3
  }

  .flex15 {
    flex: 2;
  }

  li {
    text-align: center;
  }

  ul {
    padding: 0;

    li {
      padding: 10px 0;
    }
  }

  .nodata {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
}
</style>